import React, { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import { ApplicationConfigModal, ApplicationConfigs } from "../../common/types";
import { FILE_STORAGE_API_ENDPOINT } from "../../common";
import { get } from "../../utils/requests";
import Spinner from "../../components/Spinner";
import ErrorState from "../../components/ErrorState";
import styles from "./styles.module.scss";
import ConfigTable from "../../components/ConfigTable";
import Modal from "../../components/Modal";

export interface Props {
  token: string | null;
}

const Configuration = ({ token }: Props) => {
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState<ApplicationConfigs[]>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [headers] = useState(
    new Headers({
      "Content-Type": "application/json",
      Authorization: token as string,
    })
  );
  const [selectedConfig, setSelectedConfig] =
    useState<ApplicationConfigModal>();

  useEffect(() => {
    fetchData();
  }, []);

  function updateConfigData() {
    fetchData();
  }
  function closeModal() {
    setShowModal(false);
  }

  function showAddModal(obj: any) {
    setSelectedConfig(obj);
    setShowModal(true);
  }

  function handleRowClick(obj: any) {
    setSelectedConfig(obj);
    setShowModal(true);
  }

  function fetchData() {
    const endpoint = `${FILE_STORAGE_API_ENDPOINT}`;
    get(endpoint, headers)
      .then((results) => {
        setApplications(results);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
      });
  }

  return (
    <>
      <Spinner loading={loading}>
        {error ? (
          <ErrorState />
        ) : (
          <div className={styles.wrapper}>
            <Button
              id="add-new-config-btn"
              positive
              className={styles.addAppConfigBtn}
              onClick={() => showAddModal({})}
            >
              Add config
            </Button>

            <ConfigTable
              records={applications}
              onRowClick={handleRowClick}
              handleSubmit={updateConfigData}
            />
            {selectedConfig && (
              <Modal
                configDetail={selectedConfig}
                isVisible={showModal}
                handleClose={closeModal}
                handleSubmit={updateConfigData}
              />
            )}
          </div>
        )}
      </Spinner>
    </>
  );
};

export default Configuration;
